module.exports = __webpack_public_path__ + "static/media/leaf-medium.f8f207b7.png";